import React, { useEffect, useState } from "react";
import moment from "moment";
import NavbarSidebarWrapper from "../../components/navbarSidebarWrapper";
import actions from "../../redux/actions";
import { useSelector } from "react-redux";
import ScreenLoader from "../../components/ScreenLoader";
import { notifyError, notifySuccess } from "../../components/ToastContext";

const SetPlayerCreditFantacy = () => {
  const matchList = useSelector((state) => state.fantacyMatch?.matchUpcomingList?.Result);
  const playerList = useSelector((state) => state.fantacyMatch?.matchPlayersList?.Result);

  const [selectedMatchId, setSelectedMatchId] = useState("");
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load matches
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await actions.getUpcomingList();
      setLoading(false);
    };
    load();
  }, []);

  // Load players when match selected
  useEffect(() => {
    if (!selectedMatchId) {
      setPlayers([]);
      return;
    }

    const fetchPlayers = async () => {
      setLoading(true);
      setPlayers([]);
      try {
        const res = await actions.getMatchPlayers(selectedMatchId);
        console.log("plyer", res);
        if (res?.data?.Status === false) {
          notifyError(res?.data?.Result || "Failed to load players");
          setPlayers([]);
        } else {
          const resData = res?.data?.Result || res?.data || [];
          const list = Array.isArray(resData) ? resData : [];
          const normalized = list.map(p => ({
            playerId: p.id,
            playerName: p.name,
            role: p.role,
            team: p.country,
            credit: Number(p.credit),
          }));
          setPlayers(normalized);
        }
      } catch (err) {
        setPlayers([]);
        notifyError("Failed to load players");
      }
      setLoading(false);
    };

    fetchPlayers();
  }, [selectedMatchId]);

  const handleCreditChange = (index, value) => {
    const updated = [...players];
    updated[index].credit = Number(value);
    setPlayers(updated);
  };

  const handleSaveCredits = async () => {
    try {
      setLoading(true);

      const payload = players.map(p => ({
        playerid: String(p.playerId),
        credit: String(p.credit),
      }));

      let res = await actions.postSavePlayersCredit(payload);
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Save failed");
      } else {
        notifySuccess("Credits updated successfully");
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || err.message || "Save failed");
    }
    setLoading(false);
  };

  return (
    <NavbarSidebarWrapper>
      <div className="content-header-btn mb-2">
        Set Credit Player Fantasy
      </div>

      {/* MATCH SELECT */}
      <div style={{ marginBottom: 16 }}>
        <label>Select Match:</label>
        <select
          value={selectedMatchId}
          onChange={(e) => setSelectedMatchId(e.target.value)}
          className="form-control"
        >
          <option value="">-- Select Match --</option>
          {matchList?.map((m) => {
            const teams = JSON.parse(m.TeamInfo || "[]");
            const teamNames = teams.map(t => t.teamSName).join(" vs ");

            return (
              <option key={m.MatchId} value={m.MatchId}>
                {teamNames} ({m.MatchType}) —{" "}
                {moment(m.MatchDate).format("DD MMM hh:mm A")}
              </option>
            );
          })}
        </select>
      </div>

      {/* PLAYERS */}
      {players.length > 0 && (
        <>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Player</th>
                <th>Team</th>
                <th>Role</th>
                <th>Credit</th>
              </tr>
            </thead>
            <tbody>
              {players.map((p, index) => (
                <tr key={`${selectedMatchId}-${p.playerId}`}>
                  <td>{p.playerName}</td>
                  <td>{p.team}</td>
                  <td>{p.role}</td>
                  <td style={{ width: 120 }}>
                    <input
                      type="number"
                      className="form-control"
                      value={p.credit}
                      onChange={(e) =>
                        handleCreditChange(index, e.target.value)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <button className="btn btn-success" onClick={handleSaveCredits}>
            Save Credits
          </button>
        </>
      )}

      {loading && <ScreenLoader />}
    </NavbarSidebarWrapper>
  );
};

export default SetPlayerCreditFantacy;
